import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "store/rootReducer";
import { API_URL } from "config";
import userStorage from "store/UserStorage";
import { batch } from "react-redux";
import { CommentsAdminState } from "./types";
import { setResponseMessage } from "../adminSlice";

const initialState: CommentsAdminState = {
  options: [],
  comments: [],
  comment: undefined,
  loading: false,
};

const commentsAdmin = createSlice({
  name: "commentsAdminSlice",
  initialState,
  reducers: {
    setCommentForEdit(state, action) {
      state.comment = action.payload;
      state.loading = false;
    },
    setOptions(state, action) {
      state.options = action.payload;
      state.loading = false;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setComments(state, action) {
      state.comments = action.payload;
    },
  },
});
export const {
  setLoading,
  setOptions,
  setComments,
  setCommentForEdit,
} = commentsAdmin.actions;

export const selectLoading = (state: RootState) => state.commentsAdmin.loading;

export const selectAllComments = (state: RootState) =>
  state.commentsAdmin.comments;

export const selectCommentForEditing = (state: RootState) =>
  state.commentsAdmin.comment;

export const fetchAllComments = () => async (dispatch: any) => {
  try {
    const result = await axios.get(`${API_URL}/comments`);
    dispatch(setComments(result.data.data));
  } catch (error: any) {
    console.log(`Error in fetchAllTags: ${error.message}`);
  }
};

export const addComment = (
  data: any,
  onUploadProgress: (e: ProgressEvent<EventTarget>) => void
) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const json = JSON.stringify(data);
    let token = userStorage.getUser();
    const response = await axios.post(
      `${API_URL}/comments`,
      { data: json },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        onUploadProgress,
      }
    );
    batch(() => {
      dispatch(
        setResponseMessage({
          message: "Успешно качихте коментара.",
          hasError: false,
        })
      );
      dispatch(setLoading(false));
      dispatch(fetchAllComments());
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });

    //  console.log(`Error in addTag: ${error.message}`);
  }
};

export const updateComment = (
  data: any,
  onUploadProgress: (e: ProgressEvent<EventTarget>) => void
) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const json = JSON.stringify(data.data);
    let token = userStorage.getUser();
    const response = await axios.put(
      `${API_URL}/comments/${data.id}`,
      { data: json },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        onUploadProgress,
      }
    );
    batch(() => {
      dispatch(
        setResponseMessage({
          message: "Успешно променихте коментара.",
          hasError: false,
        })
      );
      dispatch(fetchAllComments());
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });
    //  console.log(`Error in addProduct: ${error.message}`);
  }
};

export const deleteComment = (id: string) => async (dispatch: any) => {
  try {
    let token = userStorage.getUser();
    const response = await axios.delete(`${API_URL}/comments/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    batch(() => {
      dispatch(
        setResponseMessage({
          message: "Успешно изтрихте коментара.",
          hasError: false,
        })
      );
      dispatch(fetchAllComments());
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });
    //  console.log(`Error in deleteProduct: ${error.message}`);
  }
};

export const fetchComment = (id: string) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));

    let token = userStorage.getUser();
    const result = await axios.get(`${API_URL}/admin/comment-values/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch(setCommentForEdit(result.data.data));
  } catch (error: any) {
    batch(() => {
      dispatch(setLoading(false));
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
    });

    //  console.log(`Error in editProduct: ${error.message}`);
  }
};

export default commentsAdmin.reducer;
